export var GlobalDebug = (function () {
    var savedConsole = console;
    /**
     * @param {boolean} debugOn
     * @param {boolean} suppressAll
     */
    return function (debugOn, suppressAll) {
        var suppress = suppressAll || false;
        if (debugOn === false) {
            // supress the default console functionality
            console = {};
            console.log = function () { };
            // supress all type of consoles
            if (suppress) {
                console.info = function () { };
                console.warn = function () { };
                console.error = function () { };
                console.debug = function () { };
                console.trace = function () { };
                console.group = function () { };
                console.timeLog = function () { };
                console.assert = function () { };
            }
            else {
                console.info = savedConsole.info;
                console.warn = savedConsole.warn;
                console.error = savedConsole.error;
                console.debug = savedConsole.debug;
                console.trace = savedConsole.trace;
                console.group = savedConsole.group;
                console.timeLog = savedConsole.timeLog;
                console.assert = savedConsole.assert;
            }
        }
        else {
            console = savedConsole;
        }
    };
})();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVtb3ZlLWxvZ3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyZW1vdmUtbG9ncy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxXQUFXLEdBQUcsQ0FBQztJQUMxQixJQUFNLFlBQVksR0FBRyxPQUFPLENBQUM7SUFDN0I7OztPQUdHO0lBQ0gsT0FBTyxVQUFVLE9BQWdCLEVBQUUsV0FBcUI7UUFDdEQsSUFBTSxRQUFRLEdBQUcsV0FBVyxJQUFJLEtBQUssQ0FBQztRQUN0QyxJQUFJLE9BQU8sS0FBSyxLQUFLLEVBQUU7WUFDckIsNENBQTRDO1lBQzVDLE9BQU8sR0FBRyxFQUFhLENBQUM7WUFDeEIsT0FBTyxDQUFDLEdBQUcsR0FBRyxjQUFhLENBQUMsQ0FBQztZQUM3QiwrQkFBK0I7WUFDL0IsSUFBSSxRQUFRLEVBQUU7Z0JBQ1osT0FBTyxDQUFDLElBQUksR0FBRyxjQUFhLENBQUMsQ0FBQztnQkFDOUIsT0FBTyxDQUFDLElBQUksR0FBRyxjQUFhLENBQUMsQ0FBQztnQkFDOUIsT0FBTyxDQUFDLEtBQUssR0FBRyxjQUFhLENBQUMsQ0FBQztnQkFDL0IsT0FBTyxDQUFDLEtBQUssR0FBRyxjQUFhLENBQUMsQ0FBQztnQkFDL0IsT0FBTyxDQUFDLEtBQUssR0FBRyxjQUFhLENBQUMsQ0FBQztnQkFDL0IsT0FBTyxDQUFDLEtBQUssR0FBRyxjQUFhLENBQUMsQ0FBQztnQkFDL0IsT0FBTyxDQUFDLE9BQU8sR0FBRyxjQUFhLENBQUMsQ0FBQztnQkFDakMsT0FBTyxDQUFDLE1BQU0sR0FBRyxjQUFhLENBQUMsQ0FBQzthQUNqQztpQkFBTTtnQkFDTCxPQUFPLENBQUMsSUFBSSxHQUFHLFlBQVksQ0FBQyxJQUFJLENBQUM7Z0JBQ2pDLE9BQU8sQ0FBQyxJQUFJLEdBQUcsWUFBWSxDQUFDLElBQUksQ0FBQztnQkFDakMsT0FBTyxDQUFDLEtBQUssR0FBRyxZQUFZLENBQUMsS0FBSyxDQUFDO2dCQUNuQyxPQUFPLENBQUMsS0FBSyxHQUFHLFlBQVksQ0FBQyxLQUFLLENBQUM7Z0JBQ25DLE9BQU8sQ0FBQyxLQUFLLEdBQUcsWUFBWSxDQUFDLEtBQUssQ0FBQztnQkFDbkMsT0FBTyxDQUFDLEtBQUssR0FBRyxZQUFZLENBQUMsS0FBSyxDQUFDO2dCQUNuQyxPQUFPLENBQUMsT0FBTyxHQUFHLFlBQVksQ0FBQyxPQUFPLENBQUM7Z0JBQ3ZDLE9BQU8sQ0FBQyxNQUFNLEdBQUcsWUFBWSxDQUFDLE1BQU0sQ0FBQzthQUN0QztTQUNGO2FBQU07WUFDTCxPQUFPLEdBQUcsWUFBWSxDQUFDO1NBQ3hCO0lBQ0gsQ0FBQyxDQUFDO0FBQ0osQ0FBQyxDQUFDLEVBQUUsQ0FBQyJ9